import LoadingComponent from "components/Loading/LoadingComponent"
import TableContainer from "components/tables/TableContainer"
import moment from "moment"
import React, { useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { Button, Col, Form, FormFeedback, Input, Label, Row } from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
import AttendanceAction from "store/attendance-resource/actions"
import ModalAdd from "./ModalAdd"
import Skeleton from "react-loading-skeleton"
import ModalDeleteStamp from "./ModalDeleteStamp"
import { toast } from "react-toastify"
import TimeInput from "components/Common/Time"

const userName = localStorage.getItem("authUser")
  ? JSON.parse(localStorage.getItem("authUser")).name
  : ""

function DetailAttendance(props) {
  const { params, cancel } = props
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state)
  const [open, setOpen] = React.useState(false)
  const [isModal, setIsModal] = React.useState(false)
  const [isModalSweet, setIsModalSweet] = React.useState(false)
  const [payloadDelete, setPayloadDelete] = React.useState({
    date: "",
    staffId: "",
  })
  const [index, setIndex] = React.useState(0)
  const [initloading, setInitLoading] = React.useState(false)
  const [dataTemp, setDataTemp] = useState({
    id: 0,
    orderId: 0,
    orderNumber: 0,
    otherWorkId: 0,
    category: "作業",
    hour: 0,
    minute: 60,
  })

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      clockIn: "",
      clockOut: "",
      remarks: "",
      workingHours: [
        {
          id: 0,
          orderId: 0,
          orderNumber: 0,
          otherWorkId: 0,
          category: "作業",
          hour: 0,
          minute: 60,
        },
      ],
    },
    validationSchema: Yup.object({
      clockIn: Yup.string().nullable().required("出勤時間は必須項目です。"),
      clockOut: Yup.string().nullable().required("退勤時間は必須項目です。"),
      workingHours: Yup.array().of(
        Yup.object({
          hour: Yup.number().min(0).nullable(),
          minute: Yup.number().min(0).max(60).nullable(),
        })
      ),
    }),
    onSubmit: values => {
      try {
        dispatch(AttendanceAction.putData(values, callbackPut))
        toast.success(`保存しました。`)
      } catch (error) {
        console.log(error)
      }
    },
  })

  React.useEffect(() => {
    dispatch(
      AttendanceAction.getDetailHistoryDate(
        {
          date: moment(params.date).format("YYYY-MM-DD"),
          staffId: params?.staffForDetail?.value,
        },
        callbackGet
      )
    )
  }, [])

  const listDataTable = useMemo(() => {
    if (!validation) return []
    return validation?.values?.workingHours?.map((v, i) => ({
      category: v.category,
      orderNumber: v.orderNumber,
      customerName: v.customerName,
      productName: v.productName,
      totalHour: [v.hour, v.minute],
      format: i,
    }))
  }, [validation])

  const columns = React.useMemo(
    () => [
      {
        Header: "カテゴリ",
        accessor: "category",
        defaultCanSort: false,
      },
      {
        Header: "受注番号",
        accessor: "orderNumber",
        defaultCanSort: false,
      },
      {
        Header: "顧客名",
        accessor: "customerName",
        defaultCanSort: false,
      },
      {
        Header: "アイテム名",
        accessor: "productName",
        defaultCanSort: false,
      },
      {
        Header: "作業時間",
        accessor: "totalHour",
        defaultCanSort: false,
        Cell: ({ value }) => {
          return (
            <div>
              {value[0] !== 0 && value[0] !== null ? `${value[0]}時間 ` : ""}
              {value[1] !== 0 && value[1] !== null ? `${value[1]}分 ` : ""}
            </div>
          )
        },
      },
      {
        Header: "",
        accessor: "format",
        defaultCanSort: false,
        Cell: ({ cell }) => (
          <Button
            className="button"
            onClick={() => {
              setIndex(cell.row.index)
              toggle()
            }}
          >
            編集
          </Button>
        ),
      },
    ],
    []
  )

  const callbackGet = data => {
    if (!data.workingHours) data.workingHours = []
    validation.setValues(data)
  }

  const callbackPut = () => {
    dispatch(
      AttendanceAction.getDetailHistoryDate(
        {
          date: moment(params.date).format("YYYY-MM-DD"),
          staffId: params?.staffForDetail?.value,
        },
        callbackGet
      )
    )
  }

  const toggle = () => setOpen(!open)

  const handleDelete = e => {
    setIsModal(true)
    setPayloadDelete({
      date: params.date,
      staffId: params.staffForDetail?.value,
    })
  }

  return (
    <React.Fragment>
      <ModalDeleteStamp
        isModal={isModal}
        setIsModal={setIsModal}
        payload={payloadDelete}
        setOpen={setOpen}
        cancel={cancel}
      />

      <Form
        // className="mt-3"
        onSubmit={e => {
          e.preventDefault()
          validation.handleSubmit()
          return false
        }}
      >
        <Row className="mb-3">
          <Col className="text-left d-flex justify-content-start">
            {store.infoMe.data.data?.authority != "一般" &&
            store.attendance.putAttendance.loading ? (
              <Skeleton height={30} width={50} />
            ) : (
              <Button type="submit" className="me-2 button">
                保存
              </Button>
            )}
            <Button type="button" className="button" onClick={cancel}>
              キャンセル
            </Button>
          </Col>
        </Row>
        <h4 className="text-black" style={{ fontSize: 12 }}>
          {moment(params.date).format("MM月 DD日")}
        </h4>
        <h4 className="text-black" style={{ fontSize: 14 }}>
          {params?.staffForDetail?.label
            ? params?.staffForDetail?.label
            : userName}
        </h4>
        <Row>
          <Col className="text-end">
            {store.attendance.deleteData.loading ? (
              <Skeleton width={100} height={30} />
            ) : (
              <Button className="button" onClick={handleDelete}>
                打刻を削除
              </Button>
            )}

            <Button
              className="ms-2 button"
              onClick={() => {
                // const current = validation.values.workingHours
                setDataTemp({
                  orderId: "",
                  orderNumber: "",
                  otherWorkId: "",
                  category: "",
                  hour: 0,
                  minute: 0,
                })
                // current.push({
                //   orderId: "",
                //   orderNumber: "",
                //   otherWorkId: "",
                //   category: "",
                //   hour: "",
                //   minute: "",
                // })
                // validation.setFieldValue("workingHours", current)
                setIndex(validation.values.workingHours.length)
                toggle()
              }}
            >
              +
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            {store.attendance.detailDateHistory.loading || initloading ? (
              <LoadingComponent />
            ) : (
              <div className="mt-3">
                <TableContainer
                  data={listDataTable}
                  columns={columns}
                  // pagination
                  // page={params.page}
                  // size={params.size}
                  // count={store.attendance.detailDateHistory.data.length}
                  // setPageSize={size => setParams({ ...params, size })}
                  // setParams={page => setParams({ ...params, page })}
                />
              </div>
            )}
          </Col>
        </Row>

        <Row>
          <Col lg="3">
            <Label>出勤時間</Label>
            <br />
            <TimeInput
              name="clockOut"
              value={validation.values.clockIn || ""}
              onChange={value => {
                validation.setValues({ ...validation.values, clockIn: value })
              }}
            />
            {/* <Input
              name="clockIn"
              type="time"
              value={validation.values.clockIn || ""}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              invalid={
                validation.touched.clockIn && validation.errors.clockIn
                  ? true
                  : false
              }
            /> */}

            {validation.touched.clockIn && validation.errors.clockIn ? (
              <p
                type="invalid"
                style={{
                  width: "100%",
                  marginTop: "0.25rem",
                  fontSize: "80%",
                  color: "#f46a6a",
                }}
              >
                {validation.errors.clockOut}
              </p>
            ) : null}
          </Col>
          <Col lg="3">
            <Label>退勤時間</Label>
            <br />
            <TimeInput
              name="clockOut"
              value={validation.values.clockOut || ""}
              onChange={value => {
                validation.setValues({ ...validation.values, clockOut: value })
              }}
            />
            {validation.touched.clockOut && validation.errors.clockOut ? (
              <p
                type="invalid"
                style={{
                  width: "100%",
                  marginTop: "0.25rem",
                  fontSize: "80%",
                  color: "#f46a6a",
                }}
              >
                {validation.errors.clockOut}
              </p>
            ) : null}
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Label>備考</Label>
            <Input
              name="remarks"
              type="textarea"
              value={validation.values.remarks || ""}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
            />
          </Col>
        </Row>
        <ModalAdd
          date={moment(params.date).format("M月D日")}
          isOpen={open}
          toggle={toggle}
          dataTemp={dataTemp}
          setDataTemp={setDataTemp}
          validation={validation}
          index={index}
          initloading={initloading}
          setInitLoading={setInitLoading}
        />
      </Form>
    </React.Fragment>
  )
}

export default DetailAttendance
